<script>
  import { onMount } from "svelte";
  import Marquee from 'svelte-fast-marquee';

  import Message from "../Message.svelte";
  import Loading from "../Loading.svelte";
  import Clock from "../Clock.svelte";
  import Weather from "../Weather.svelte";

  import { parseMode } from "../helpers";
  import { replaceStopName } from "../helpers";
  import { tooltip } from '../utils';
  import { getLocalStorage } from '../utils';
  import { VERSION } from "../version"

  export let id;
  export let limit;
  export let type;
  export let systemUrl;

  let hashHeader = getLocalStorage('instanceId')

  localStorage.setItem('board-version', VERSION)

  // GUI466 - Central de Camionagem de Guimarães - novo GTFS Eleven
  let allowed_ids = ['GUI466_32','GUI466_31','GUI466_30','GUI466_29','GUI466_28','GUI466_27','GUI466_26','GUI466_25',
    'GUI466_24','GUI466_23','GUI466_22','GUI466_21','GUI466_20','GUI466_19','GUI466_18','GUI466_17','GUI466_16','GUI466_15',
    'GUI466_14','GUI466_13','GUI466_12','GUI466_11','GUI466_10','GUI466_9','GUI466_8','GUI466_7','GUI466_6','GUI466_5',
    'GUI466_4','GUI466_3','GUI466_2','GUI466_1','GUI466']
  //let allowed_ids = [] // para todos

  let data = {};

  let show_clock = true;
  let show_date = true;

  let lat = 41.4401432939301;
  let lon = -8.303191012571181;

  let delay_minutes = type == 'departures' ? 0 : 3;

  let delay_ms = delay_minutes * -1 * 60 * 1000;

  let request_type = (type == 'departures' || type == 'arrivals') ? type : 'departures';

  let request_type_trans =  type == 'departures' ? 'partidas' : 'chegadas';

  let currDate = 0;

  let destMaxChars = (window.innerWidth - 848) / 17; //848px is the total size of all other columns; 17 has an "educated guess" to the average width of a character

  const request = async () => {

    if(allowed_ids.length > 0 && allowed_ids.find(item => item == id) == undefined){
      console.log("Not allowed");
      data = undefined;
      return;
    }

    limit = isNaN(parseInt(limit)) ? 10 : parseInt(limit);

    const res = await fetch(
      `https://${systemUrl}/v3/busdata/stop?stop_id=${id}&type=${request_type}&delay_ms=${delay_ms}&limit=${limit}`,
      {
        headers: {
            'device-id': hashHeader,
            'board-version': VERSION
        }
      }
    );
    const resJson = await res.json();

    let results = [];
    let index = 0;

    currDate = resJson.time_utc;

    resJson.services.map((d) => {

      let dest = ''

      switch (d.agency) {
        case "FLX":
          dest = d.next.destination.replace('FlixBus: ','')  + ' : destino ' + d.next.last_stop_name;
          break;
        case "RNE":
          dest = d.next.destination;
          break;
        default:
          dest = d.next.stop_sequence == d.next.max_stop_sequence ? d.next.original_route_long_name : d.next.destination
      }

      let origin = d.agency == 'EXT' ? 
        d.next.original_route_long_name :
        d.agency == 'RNE' ? 
          (d.next.destination.includes(' - Bus ') ?
            d.next.first_stop_name + ' - Bus ' + d.next.destination.split(' - Bus ')[1] :
            d.next.first_stop_name !== undefined ? d.next.first_stop_name : dest) :
        d.next.first_stop_name !== undefined ? 
          d.next.first_stop_name : dest;

      if (d.next != null) {
        results.push({
          id: d.no,
          line: d.next.line,
          destination: replaceStopName(dest),
          origin: replaceStopName(origin),
          platform: d.next.platform != null ? d.next.platform : "",
          arrivalTimeRelative: Math.max(0, Math.floor(d.next.arrival_ms / 1000 / 60)),
          arrivalTimeRelativeClock: new Intl.DateTimeFormat("pt", {
            hour: "numeric",
            minute: "numeric",
          }).format(new Date(currDate + d.next.arrival_ms)),
          arrivalDelayMs: d.next.arrival_delay_ms,
          arrivalTimeRelativeDelay: Math.max(0, Math.floor(d.next.arrival_delay_ms / 1000 / 60)),
          arrivalDelay: Math.floor((d.next.arrival_delay_ms - d.next.arrival_ms) / 1000 / 60),
          arrivalTimeRelativeDelayClock: new Intl.DateTimeFormat("pt", {
            hour: "numeric",
            minute: "numeric",
          }).format(new Date(currDate + d.next.arrival_delay_ms)),
          departureTimeRelative: Math.max(0, Math.floor(d.next.departure_ms / 1000 / 60)),
          departureTimeRelativeClock: new Intl.DateTimeFormat("pt", {
            hour: "numeric",
            minute: "numeric",
          }).format(new Date(currDate + d.next.departure_ms)),
          departureDelayMs: d.next.departure_delay_ms,
          departureTimeRelativeDelay: Math.max(0, Math.floor(d.next.departure_delay_ms / 1000 / 60)),
          departureDelay: Math.floor((d.next.departure_delay_ms - d.next.departure_ms) / 1000 / 60),
          departureTimeRelativeDelayClock: new Intl.DateTimeFormat("pt", {
            hour: "numeric",
            minute: "numeric",
          }).format(new Date(currDate + d.next.departure_delay_ms)),
          departureTimeRelative: Math.max(0, Math.floor(d.next.departure_ms / 1000 / 60)),
          agency: d.agency,
          mode: parseMode(d.agency,dest),
          nextLoad: d.next.load,
          stopSequence: d.next.stop_sequence,
          maxStopSequence: d.next.max_stop_sequence,
          index: index % 2
        });
        index++;
      }
    });

    data.name = resJson.name;
    data.departures = results;
  };

  onMount(() => {

    if (hashHeader != null) {
      request(); // first request
    } else {
      setTimeout(() => { // wait for js has time to calculate hashHeader and set it on localStorage
        hashHeader = getLocalStorage('instanceId')
        if (hashHeader != null) {
          request(); // first request
        } else {
          setTimeout(() => { // wait again for js has time to calculate hashHeader and set it on localStorage
            hashHeader = getLocalStorage('instanceId')
            request()
          }, 3000);
        }
        request()
      }, 1000);
    }

    const interval = setInterval(request, 60000); // request every 60 seconds

    return () => {
      clearInterval(interval);
    };
  });
</script>

<div class="flex-1 w-1/2 font-gui" data-id={`stop-${id}`}>
    {#if data}
      {#if data.name}
        <div>
          <div class="header-bg-{type} p-5">
            <div class="flex items-center justify-between">
              <div class="inline-flex">
                <img class="mr-10 ml-6 logo-system-gui" alt="Logo Cidade" src="img/logo-GUI-b.png">
                {#if type === 'departures'}
                  <h2 class="ml-10">PARTIDAS</h2>
                {:else}
                  <h2 class="ml-10">CHEGADAS</h2>
                {/if}
              </div>
              <div class="inline-flex items-center mr-6">
                <div class="weather mr-16">
                  <Weather {lat} {lon}/>
                </div>
                <div class="block">
                  <div class="clock">
                    <Clock {currDate} {show_clock}/>
                  </div>
                  <div class="date">
                    <Clock {currDate} {show_date}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col w-full h-full whitespace-nowrap">
            <div class="flex flex-row h-16 bg-2 px-4 header-font">
              <div class="w-40 p-2 my-auto text-left" use:tooltip={VERSION}>Operador</div>
              <div class="w-28 my-auto text-left">Linha</div>
              {#if type === 'departures'}
                <div class="flex-grow my-auto text-left"></div>
              {:else}
                <div class="flex-grow my-auto text-left">Origem</div>
              {/if}
              <div class="w-20 p-2 my-auto text-center">Cais</div>
              {#if type === 'departures'}
                <div class="w-44 p-2 my-auto text-center">Partida</div>
              {:else}
                <div class="w-44 p-2 my-auto text-center">Chegada</div>
              {/if}
              <div class="w-80 p-2 my-auto text-center">Info</div>
            </div>
            {#each data.departures as {
              id,
              line,
              destination,
              origin,
              arrivalTimeRelative,
              arrivalTimeRelativeClock,
              arrivalDelayMs,
              arrivalTimeRelativeDelay,
              arrivalDelay,
              arrivalTimeRelativeDelayClock,
              departureTimeRelative,
              departureTimeRelativeClock,
              departureDelayMs,
              departureTimeRelativeDelay,
              departureDelay,
              departureTimeRelativeDelayClock,
              agency,
              mode,
              platform,
              nextLoad,
              stopSequence,
              maxStopSequence,
              index
            }}
              <div class="flex flex-row h-custom text-primary px-4 bg-{type}-{index}" data-id={id}>
                <div class="w-40 p-1 align-middle text-center flex-shrink-0 flex-grow-0">
                  <img class="h-full w-full" src={mode.iconUrl} alt={mode.name}/>
                </div>
                <!--<div class="w-40 my-auto color-white flex-shrink-0 flex-grow-0">
                  {mode.name}
                </div>-->
                <div class="w-28 text-left pr-2 my-auto font-bold color-white flex-shrink-0 flex-grow-0">
                  {line}
                </div>
                {#if type === 'departures'}
                  {#if destination.length > destMaxChars }
                      <Marquee pauseOnHover={true} speed={destination.length * 0.3}>
                        <span class="color-white pr-10">{destination}</span>
                      </Marquee>
                  {:else}
                    <div class="flex-grow text-left pr-2 my-auto color-white">
                      {destination}
                    </div>
                  {/if}
                {:else}
                  {#if origin.length > destMaxChars }
                      <Marquee pauseOnHover={true} speed={origin.length * 0.3}>
                        <span class="color-white pr-10">{origin}</span>
                      </Marquee>
                  {:else}
                    <div class="flex-grow text-left pr-2 my-auto color-white">
                      {origin}
                    </div>
                  {/if}
                {/if}
                <div class="w-20 my-auto align-middle text-center flex-shrink-0 flex-grow-0">
                  {#if agency != 'RNE'}
                    {#if platform}
                      <p class="time-text color-white">{platform}</p>
                    {:else}
                      <p class="time-text color-white">--</p>
                    {/if}
                  {:else}
                    <p class="time-text color-white">1 a 5</p>
                  {/if}
                </div>
                {#if type === 'departures'}
                  <!-- PARTIDAS -->
                  <div class="w-44 my-auto text-center color-white font-bold flex-shrink-0 flex-grow-0">
                    {#if departureTimeRelativeDelay == 0}
                      <span class="mt-9px ml-3" use:tooltip={departureDelay}>{departureTimeRelativeClock}</span>
                    {:else}
                      {#if departureTimeRelativeDelay != departureTimeRelative}
                        {#if departureDelay > 0}
                          <div class="inline-flex">
                            <img width="40px" class="bounce-effect" src="../img/svg/bullet-red.svg" alt="Atrasado"/>
                            <span class="mt-9px ml-3" use:tooltip={arrivalDelay}>{departureTimeRelativeClock}</span>
                          </div>
                        {:else}
                          <div class="inline-flex">
                            <img width="38px" src="../img/svg/bullet-green-info.svg" alt="Atrasado"/>
                            <span class="mt-9px ml-3" use:tooltip={arrivalDelay}>{departureTimeRelativeClock}</span>
                          </div>
                        {/if}
                      {:else}
                        <span class="mt-9px ml-3" use:tooltip={departureDelay}>{departureTimeRelativeClock}</span>
                      {/if}
                    {/if}
                  </div>
                  <div class="w-80 p-2 my-auto text-center color-white flex-shrink-0 flex-grow-0">
                    {#if departureTimeRelativeDelay == 0}
                      <div class="inline-flex">
                        <!-- na primeira paragem não há informação de atraso, por isso o autocarro pode ainda nem ter partido -->
                        {#if departureDelayMs < 0}
                          {#if stopSequence != 1}
                            <img src="../img/svg/arrival.svg" alt="Chegada" width="40px"/>
                            <span class="my-auto info-departure fade-text">PARTIU</span>
                          {/if}
                        {:else}
                          <img src="../img/svg/arrival.svg" alt="Chegada" width="40px"/>
                          <span class="my-auto info-departure fade-text">EMBARQUE</span>
                        {/if}
                      </div>
                    {:else}
                      {#if departureTimeRelativeDelay != departureTimeRelative && departureTimeRelativeDelay != 0}
                        <div class="inline-flex">
                          <img width="35px" src="../img/svg/departure-time.svg" alt="Atrasado"/>
                          <p class="mt-2px ml-1 color-info-time">NOVA HORA <span class="font-bold-2">{departureTimeRelativeDelayClock}</span></p>
                        </div>
                      {:else}
                        <span></span>
                      {/if}
                    {/if}
                  </div>
                {:else}
                  <!-- CHEGADAS -->
                  <div class="w-44 my-auto text-center color-white font-bold flex-shrink-0 flex-grow-0">
                    {#if arrivalTimeRelativeDelay == 0}
                      <span class="mt-9px ml-3" use:tooltip={arrivalDelay}>{arrivalTimeRelativeClock}</span>
                    {:else}
                      {#if arrivalTimeRelativeDelay != arrivalTimeRelative}
                        {#if arrivalDelay > 0}
                          <div class="inline-flex">
                            <img width="40px" class="bounce-effect mt-7px" src="../img/svg/bullet-red.svg" alt="Atrasado"/>
                            <span class="mt-9px ml-3" use:tooltip={arrivalDelay}>{arrivalTimeRelativeClock}</span>
                          </div>
                        {:else}
                          <div class="inline-flex">
                            <img width="38px" src="../img/svg/bullet-green-info.svg" alt="Atrasado"/>
                            <span class="mt-9px ml-3" use:tooltip={arrivalDelay}>{arrivalTimeRelativeClock}</span>
                          </div>
                        {/if}
                      {:else}
                        <span class="mt-9px ml-3" use:tooltip={arrivalDelay}>{arrivalTimeRelativeClock}</span>
                      {/if}
                    {/if}
                  </div>
                  <div class="w-80 p-2 my-auto text-center color-white flex-shrink-0 flex-grow-0">
                    {#if arrivalTimeRelativeDelay == 0}
                      <div class="inline-flex">
                        <!-- na só mostra o CHEGOU na última paragem, porque numa paragem intermédia pode ter já partido -->
                        {#if arrivalDelayMs < 0}
                          {#if stopSequence == maxStopSequence}
                            <img src="../img/svg/arrival.svg" alt="Chegada" width="40px"/>
                            <span class="info-departure fade-text">CHEGOU</span>
                          {/if}
                        {:else}
                          <img src="../img/svg/arrival.svg" alt="Chegada" width="40px"/>
                          <span class="info-departure fade-text">A CHEGAR</span>
                        {/if}
                      </div>
                    {:else}
                      {#if arrivalTimeRelativeDelay != arrivalTimeRelative && arrivalTimeRelativeDelay != 0}
                        <div class="inline-flex">
                          <img width="35px" src="../img/svg/departure-time.svg" alt="Atrasado"/>
                          <p class="mt-2px ml-1 color-info-time">NOVA HORA <span class="font-bold-2">{arrivalTimeRelativeDelayClock}</span></p>
                        </div>
                      {:else}
                        <span></span>
                      {/if}
                    {/if}
                  </div>
                {/if}
              </div>
            {:else}
              <div class="table-row">
                <Message title="Sem {request_type_trans} previstas..." text="Não existem {request_type_trans} definidas para esta paragem para as próximas horas."/>
              </div>
            {/each}
          </div>
        </div>
      {:else}
        <div class="mt-32">
          <div class="w-full flex flex-col justify-center items-center text-center">
            <div class="">
              <img width="150px" alt="Bus Gif Loading" src="img/bus-anim.gif">
            </div>
          </div>
          <Loading title="A carregar dados de {request_type_trans}..." text="Estamos a obter os dados de {request_type_trans} definidas para esta paragem para as próximas horas."/>
        </div>
      {/if}
    {:else}
      <div>
        <div class="flex items-center m-10">
          <img width="220px" alt="Logo Cidade" src="img/logo-{id.substring(0,3)}.png">
        </div>
        <Message title="Iremos ser breves..." text="Estamos com alguns problemas a mostrar a informação ({id})"/>
      </div>
    {/if}
  </div>
